export const DRAWER_WIDTH = 260;
export const DRAWER_MOBILE_WIDTH = "100vw";
export const DRAWER_TABLET_WIDTH = 600;
export const DRAWER_DESKTOP_WIDTH = 700;
